// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
    <missing-access-warning
      missing-access="CST_DEPOSIT_ACCOUNT_READ">
    </missing-access-warning>

    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Deposit number:</span>
        <span class="value">{{\$ctrl.termDeposit.productNumber}}
        </span>
      </div>
    </div>

    <h2 class="section-header">Update term deposit parameters</h2>

    <form name="\$ctrl.form">
      <validator condition="\$ctrl.hasValidOwnerConfiguration"></validator>
      <table class="misc-transaction__table table table--generate-row-ids">
        <thead>
        <th></th>
        <th>Property</th>
        <th>Current state</th>
        <th>Target state</th>
        </thead>
        <tbody>
        <tr>
          <td></td>
          <td>Tax exempted</td>
          <td>{{\$ctrl.termDeposit.taxExempted | prettyBoolean}}</td>
          <td>
            <select
              ng-model="\$ctrl.input.taxExempted"
              boolean-options>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.termDepositProduct.accrualScheduler.enabled">
          <td></td>
          <td>Accrued interest</td>
          <td>
            <cash ng-model="\$ctrl.termDeposit.accruedInterest"
                  ng-disabled="true"></cash>
          <td>
            <cash ng-model="\$ctrl.input.accruedInterest"></cash>
          </td>
        </tr>
        <tr ng-if="\$ctrl.termDepositProduct.accrualScheduler.enabled">
          <td></td>
          <td>Last interest accrual</td>
          <td>{{\$ctrl.termDeposit.lastAccrualDate | nxDate}}</td>
          <td>
            <date output-format="local-date"
                  ng-required="\$ctrl.input.accruedInterest"
                  ng-model="\$ctrl.input.lastAccrualDate"
                  init-with-null="true"
                  max="\$ctrl.branchSystemDate | nxDate"></date>
          </td>
        </tr>
        <tr ng-if="\$ctrl.termDeposit.creditingStrategy !== 'NOT_ALLOWED'">
          <td></td>
          <td>Last interest crediting</td>
          <td>{{\$ctrl.termDeposit.creditingScheduler.lastExecution | nxDate}}</td>
          <td>
            <date output-format="local-date"
                  ng-model="\$ctrl.input.lastCreditingDate"
                  init-with-null="true"
                  max="\$ctrl.branchSystemDate | nxDate"></date>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Initial deposit date</td>
          <td>{{\$ctrl.termDeposit.initialDepositDate | nxDate}}</td>
          <td>
            <date output-format="local-date"
                  ng-model="\$ctrl.input.initialDepositDate"
                  init-with-null="true"
                  min="\$ctrl.termDeposit.createdOn | nxDate"
                  max="\$ctrl.branchSystemDate | nxDate"></date>
          </td>
        </tr>
        <tr ng-if="\$ctrl.input.maturityStrategy === 'RENEW_WITHOUT_INTEREST' || \$ctrl.input.creditingStrategy === 'PRODUCT_TRANSFER'">
          <td></td>
          <td>Related deposit</td>
          <td>{{\$ctrl.termDeposit.selectedRelatedAccount.productNumber}}</td>
          <td>
            <account-select
              value-field="'id'"
              field-mapping="{accountGroup: null, accountGroupMaxLength: null, name: 'label'}"
              options="\$ctrl.accounts"
              ng-model="\$ctrl.selectedRelatedAccount"
              ng-required="\$ctrl.input.creditingStrategy === 'PRODUCT_TRANSFER'"
              config="\$ctrl.accountSelectConfig">
            </account-select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Maturity strategy</td>
          <td>{{\$ctrl.termDeposit.maturityStrategyLabel}}</td>
          <td>
            <select
              ng-model="\$ctrl.input.maturityStrategy"
              ng-options="o.value as o.label for o in \$ctrl.termDepositProduct.maturityStrategies"
              required>
            </select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Crediting strategy</td>
          <td>{{\$ctrl.termDeposit.creditingStrategyLabel}}</td>
          <td>
            <select
              ng-model="\$ctrl.input.creditingStrategy"
              ng-options="o.value as o.label for o in \$ctrl.termDepositProduct.creditingStrategies"
              required>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.input.creditingStrategy !== 'NOT_ALLOWED'">
          <td></td>
          <td>Interests crediting interval</td>
          <td>{{\$ctrl.termDeposit.creditingScheduler.interval}}</td>
          <td>
            <input
              required
              type="number"
              class="value"
              ng-model="\$ctrl.input.creditingInterval"
              min="1"
              max="{{\$ctrl.termDepositProduct.maximumTerm}}">
          </td>
        </tr>
        <tr ng-if="\$ctrl.input.creditingStrategy !== 'NOT_ALLOWED'">
          <td></td>
          <td>Interest crediting cycle type</td>
          <td>{{\$ctrl.getCycleTypeLabel(\$ctrl.termDeposit.creditingScheduler.cycleType)}}</td>
          <td>
            <select
              required
              ng-model="\$ctrl.input.creditingCycleType"
              ng-options="c.value as c.label for c in \$ctrl.cycleTypes">
            </select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Term:</td>
          <td>
            <glue-container append="'days'">
              <input disabled type="number" ng-model="\$ctrl.termDeposit.depositTerm"/>
            </glue-container>
          </td>
          <td>
            <glue-container append="'days'">
              <input
                ng-required="true"
                type="number"
                class="value"
                ng-disabled="\$ctrl.termEditingDisabled()"
                ng-model="\$ctrl.input.depositTerm"
                min="{{\$ctrl.termDepositProduct.minimalTerm}}"
                max="{{\$ctrl.termDepositProduct.maximumTerm}}">
            </glue-container>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Keep special interest rate after rollover:</td>
          <td>{{\$ctrl.termDeposit.keepSpecialInterestRateEnabled | prettyBoolean}}</td>
          <td>
            <select
              required
              ng-model="\$ctrl.input.keepSpecialInterestRateEnabled"
              boolean-options>
            </select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Special interest rate:</td>
          <td>{{\$ctrl.termDeposit.depositInterest.specialInterestRate | prettyBoolean}}</td>
          <td>
            <select
              required
              ng-model="\$ctrl.input.depositInterest.specialInterestRate"
              boolean-options>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.input.depositInterest.specialInterestRate">
          <td></td>
          <td>Interest rate:</td>
          <td>
            <glue-container append-percentage="true">
              <input disabled type="number" ng-model="\$ctrl.termDeposit.depositInterest.interestRate"/>
            </glue-container>
          </td>
          <td>
            <glue-container append-percentage="true">
              <input
                required
                type="number"
                min="0"
                max="1000"
                step="0.00001"
                ng-change="\$ctrl.updatePreterminationRates()"
                ng-model="\$ctrl.input.depositInterest.interestRate"/>
            </glue-container>
          </td>
        </tr>
        <tr ng-if="\$ctrl.input.depositInterest.specialInterestRate">
          <td></td>
          <td colspan="2">Auto-calculate pretermination interest rates:</td>
          <td>
            <select
              required
              ng-change="\$ctrl.updatePreterminationRates()"
              ng-model="\$ctrl.input.autoCalculatePreterminationInterestRates"
              boolean-options>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.input.depositInterest.specialInterestRate">
          <td></td>
          <td>Pretermination first half interest rate <span ng-if="\$ctrl.input.autoCalculatePreterminationInterestRates">(25% of interest rate):</span></td>
          <td>
            <glue-container append-percentage="true">
              <input disabled type="number" ng-model="\$ctrl.termDeposit.depositInterest.preterminationFirstHalfInterestRate"/>
            </glue-container>
          </td>
          <td>
            <glue-container append-percentage="true">
              <input type="number"
                     ng-model="\$ctrl.input.depositInterest.preterminationFirstHalfInterestRate"
                     ng-disabled="\$ctrl.input.autoCalculatePreterminationInterestRates"/>
            </glue-container>
          </td>
        </tr>
        <tr ng-if="\$ctrl.input.depositInterest.specialInterestRate">
          <td></td>
          <td>Pretermination second half interest rate <span ng-if="\$ctrl.input.autoCalculatePreterminationInterestRates">(50% of interest rate):</span></td>
          <td>
            <glue-container append-percentage="true">
              <input disabled
                     type="number"
                     ng-model="\$ctrl.termDeposit.depositInterest.preterminationSecondHalfInterestRate"/>
            </glue-container>
          </td>
          <td>
            <glue-container append-percentage="true">
              <input type="number"
                     ng-model="\$ctrl.input.depositInterest.preterminationSecondHalfInterestRate"
                     ng-disabled="\$ctrl.input.autoCalculatePreterminationInterestRates"/>
            </glue-container>
          </td>
        </tr>
        <tr ng-if="\$ctrl.termDeposit.depositSubgroup === 'PLEDGE' && \$ctrl.termDeposit.status === 'PENDING'">
          <td></td>
          <td>Initial placement type:</td>
          <td>{{\$ctrl.termDeposit.initialPlacementType | prettyEnum}}</td>
          <td>
            <select
              required
              ng-model="\$ctrl.input.initialPlacementType"
              ng-options="o.value as o.label for o in \$ctrl.initialPlacementTypes">
            </select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Casa class code:</td>
          <td>{{\$ctrl.termDeposit.casaClassCode | prettyCasaClassCode}}</td>
          <td>
            <select
              required
              ng-model="\$ctrl.input.casaClassCode"
              ng-options="o.value as o.label for o in \$ctrl.casaClassCodes">
            </select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>PDIC type</td>
          <td>{{\$ctrl.termDeposit.pdicTypeName}}</td>
          <td>
            <select
              required
              ng-model="\$ctrl.input.pdicTypeId"
              ng-change="\$ctrl.pdicCasaTypesChanged()"
              ng-options="o.id as o.name for o in \$ctrl.pdicCasaTypes">
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.isCorporate">
          <td></td>
          <td>Signatories:</td>
          <td>{{\$ctrl.signatoryNames.join(' | ')}}</td>
          <td>
            <multiselect
                         items="\$ctrl.signatoryRelatives"
                         ng-model="\$ctrl.input.signatoryIds"
                         label-property="'effectiveName'"
                         value-property="'id'">
            </multiselect>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Extra number:</td>
          <td>{{\$ctrl.termDeposit.extraNumber}}</td>
          <td>
            <input
              type="text"
              ng-model="\$ctrl.input.extraNumber">
          </td>
        </tr>
        </tbody>
      </table>

      <custom-field-input
        group="'DEPOSIT'"
        available-custom-fields="\$ctrl.termDepositProduct.productDefinition.customFieldDefinitionIds"
        assigned-category-ids="\$ctrl.input.categoryIds"
        custom-field-values="\$ctrl.input.customFieldValues"
        branch-id="\$ctrl.termDeposit.branchId"
        edit-mode="true"
        customer-id="\$ctrl.termDeposit.customerId">
      </custom-field-input>

      <div ng-if="\$ctrl.multipleAccountOwnershipEnabled">
        <h2 class="section-header">Account owners</h2>
        <product-owners ownership="\$ctrl.input.ownership" edit-mode="true">
        </product-owners>
      </div>

      <div class="buttons">
        <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-primary" ng-click="\$ctrl.update()" ng-disabled="\$ctrl.form.\$invalid">Update</button>
      </div>

    </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/edit-term-deposit/edit-term-deposit.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;